// Configuración dinámica de Google Analytics por cliente
import params from "@/params.js";

const gaModule = {
  // Inicializa Google Analytics con el ID correcto del cliente
  init() {
    const gaId = params.analytics && params.analytics.gaId;

    // Si no hay ID de GA configurado, no inicializar
    if (!gaId) {
      // console.warn("No se ha configurado un ID de Google Analytics");
      return;
    }

    // Cargar el script de GA dinámicamente
    const gaScript = document.createElement("script");
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(gaScript);

    // Configurar GA
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", gaId);
  },

  // Envía un evento de cambio de página a GA
  trackPageView(path) {
    const gaId = params.analytics && params.analytics.gaId;
    if (!gaId || !window.gtag) return;

    window.gtag("config", gaId, {
      page_path: path
    });
  },

  // Envía un evento personalizado a GA
  trackEvent(category, action, label, value) {
    if (!window.gtag) return;

    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

export default gaModule;
